import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  constructor() {}

  setEncryptedCache(data: any) {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), 'SPC').toString();
    const cache = {
      data: encrypted,
      timestamp: Date.now()
    };
    localStorage.setItem('p', JSON.stringify(cache));
  }

  getEncryptedCache() {
    const item = localStorage.getItem('p');
    if (!item) return null;

    const parsed = JSON.parse(item);
    // 15 minutes
    if (Date.now() - parsed.timestamp > 15 * 60 * 1000) {
      localStorage.removeItem('p');
      return null;
    }

    const bytes = CryptoJS.AES.decrypt(parsed.data, 'SPC');
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
}
